import loadingButtonDirective from './loadingButton/loadingButton.directive.js';
import itemListDirective from "./itemList/itemList.directive.js";
import userExists from './userExists/userExists.directive.js';
import alertsDirective from './alerts/alerts.directive.js';
import alertDirective from './alerts/alert.directive.js';
import creditCardInputDirective from './creditCardInput.directive.js';
import creditCardExpInputDirective from './creditCardExpInput.directive.js';
import ngBreakpointClass from './ngBreakpointClass/ngBreakpointClass.directive.js';
import extraValidityDirective  from './extraValidity/extraValidity.directive.js';
import logoutLinkDirective from './logoutLink.directive.js';
import modelMirrorDirective from './modelMirror/modelMirror.directive.js';

angular.module('app.directives', ['ui.mask', 'credit-cards', 'ngTouch'])

  .directive('creditCardInput', creditCardInputDirective)

  .directive('creditCardExpInput', creditCardExpInputDirective)

  .directive('logoutLink', logoutLinkDirective)

  .directive('alerts', alertsDirective)

  .directive('alert', alertDirective)

  .directive('loadingButton', loadingButtonDirective)

  .directive('itemList', itemListDirective)

  .directive('userExists', userExists)

  .directive('ngBreakpointClass', ngBreakpointClass)

  .directive('extraValidity', extraValidityDirective)

  .directive('modelMirror', modelMirrorDirective);




/** WEBPACK FOOTER **
 ** ./src/app/shared/directives/directives.module.js
 **/